
import React from "react";
import { Photo } from "@/types/photos";
import { FileText } from "lucide-react";
import FadeIn from "@/components/FadeIn";
import PhotoCard from "@/components/PhotoCard";

interface RejectedPhotosTabProps {
  photos: Photo[];
}

const RejectedPhotosTab: React.FC<RejectedPhotosTabProps> = ({
  photos,
}) => {
  return (
    <>
      {photos.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {photos.map((photo, index) => (
            <FadeIn key={photo.id} delay={index * 50}>
              <PhotoCard {...photo} />
            </FadeIn>
          ))}
        </div>
      ) : (
        <div className="text-center py-12">
          <div className="flex justify-center mb-4 text-muted-foreground">
            <FileText className="h-16 w-16" />
          </div>
          <h3 className="text-lg font-medium">No rejected photos</h3>
          <p className="text-muted-foreground">
            You haven't rejected any photos yet
          </p>
        </div>
      )}
    </>
  );
};

export default RejectedPhotosTab;
